import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { startSearch } from './startSearch';
import { deselectAllRecordings } from './deselectAllRecordings';

import type { Store, HotjarFilters } from '../../../store/list/types';

/**
 * Update model and localstorage with hotjar filters
 * Only watchedFilter for now
 */
export const saveHotjarFilters = (store: Store, hotjarFilters: HotjarFilters): void => {
  const { setHotjarFilters } = store.getState();

  setHotjarFilters(hotjarFilters);
  LocalStorage.set('hotjarFiltersPreferences', hotjarFilters);

  // relaunch search with updated filters
  startSearch(store);
  // Clear any selections on filter change
  deselectAllRecordings(store);
};
